export default "__VITE_ASSET__BZy12ya___"